/**
 * Utilitários para validação e formatação de IDs de grupos do Telegram
 */

/**
 * Valida se um ID de grupo é válido
 * Deve começar com '-' seguido de números
 * Exemplo: -1001234567890
 */
export const validateGroupId = (id) => {
  if (!id) return false;
  return /^-\d+$/.test(id.toString().trim());
};

/**
 * Formata um ID de grupo
 * Remove espaços em branco
 */
export const formatGroupId = (id) => {
  if (!id) return '';
  return id.toString().trim();
};

/**
 * Valida múltiplos group IDs
 * Retorna um objeto com { isValid: boolean, errors: string[] }
 */
export const validateGroupIds = (vipId, logsId) => {
  const errors = [];

  if (vipId && !validateGroupId(vipId)) {
    errors.push('ID Grupo VIP inválido (deve ser: -1001234567890)');
  }

  if (logsId && !validateGroupId(logsId)) {
    errors.push('ID Grupo de Notificações inválido (deve ser: -1001234567890)');
  }

  return {
    isValid: errors.length === 0,
    errors
  };
};

/**
 * Sanitiza e formata grupo IDs para envio à API
 */
export const sanitizeGroupIds = (vipId, logsId) => {
  return {
    vip_id: vipId ? formatGroupId(vipId) : undefined,
    logs_id: logsId ? formatGroupId(logsId) : undefined
  };
};
